import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import SearchHeader from "./SearchHeader"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        loading,
        pageType
    } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading, pageType: state.pageType }))
    
    const isSearch = pageType === "search";
    return (
        // ns-p-4 ns-my-0
        <>
            {isSearch && <SearchHeader />}
            <div class={`ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ${isSearch ? 'ns-search-page':''}`}
                data-nosto-element={type}>
                {foundProducts && <Sidebar />}
                {/* <Sidebar /> */}
                <div
                // ns-pl-md-5
                    class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                    style={{ position: loading ? "relative" : "initial" }}
                    >
                    { children({ loading, foundProducts }) }
                </div>
            </div>
        </> 
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

